import { createStore } from "./createStore";
import { authLogin } from "../utils/api";
import type { StateCreator } from "zustand";
import { handleApiError } from "../utils/errorHandler";

interface AuthState {
  user: string | null;
  token: string | null;
  isLoading: boolean;
  error: string | null;

  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  loadFromStorage: () => void;
}

const authStore: StateCreator<AuthState> = (set) => ({
  user: null,
  token: null,
  isLoading: false,
  error: null,

  login: async (username, pass) => {
    set({ isLoading: true, error: null });

    try {
      const { token } = await authLogin({ username, pass });

      localStorage.setItem("auth_token", token);
      localStorage.setItem("auth_username", username);

      set({ 
        user: username, 
        token, 
        isLoading: false,
        error: null 
      });
    } catch (err: unknown) {
      const errorMessage = handleApiError(
        err,
        "Ошибка входа. Попробуйте позже."
      );
      set({ error: errorMessage, isLoading: false });
    }
  },

  logout: () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_username");
    set({ 
      user: null, 
      token: null, 
      error: null 
    });
  },

  loadFromStorage: () => {
    const tokenFromLs = localStorage.getItem("auth_token");
    const usernameFromLs = localStorage.getItem("auth_username");

    if (!tokenFromLs) {
      set({ 
        user: null, 
        token: null, 
        error: null 
      });
      return;
    }

    set({
      token: tokenFromLs,
      user: usernameFromLs || null,
      error: null,
    });
  },
});

const useAuthStore = createStore(authStore, "AuthStore");

if (typeof window !== "undefined") {
  useAuthStore.getState().loadFromStorage();
}

export { useAuthStore };